import React, { useEffect, useState } from 'react';
import { translate } from '../../base/i18n';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getFilterDocumentListByMode, getFocusItem } from '../functions';
import DocumentItem from './ShareDocumentItem';
import { DEFAULT_INDEX } from '../constants';
import { setFocusShareDocument } from '../actions';

const DocumentListStyled = styled.div`    
    overflow-x: hidden;
    overflow-y: auto; 
    height: 100%; 
    border-top: 1px solid #d5d5d5;
    
    .document_item:not(.document_item:nth-child(1)) {
        .name {
            border-top: 1px solid #d5d5d5;
        }
    }

    .status_label {
        background: #109cef;
        width: 6px;
        height: 100%;
        position: absolute;
        right: 0;
    }

    .document_item {     
        display: flex;
        flex-direction: column;
        gap: 1px;
        height: 100%;

        .item_hide {
            display: none;
        }
        .item_open {
            height: ${props => props.depthItem ? "100%" : "auto"};
            .image {
                height: ${props => props.depthItem ? "calc(100% - 103px)" : "auto"};
                overflow: ${props => props.depthItem ? "auto" : "hidden"};
            }
        }

        .item_${props => props.focusUuid} {
            .name {
                background: #d5d5d5;
            }
        }
        
        .page {
            position: relative;
            cursor: pointer; 
            border: 1px solid #d5d5d5!important; 
            box-sizing: border-box;
            &.page_${props => props.focusUuid}_${props => props.focusIndex} {
                border: 1px solid #1FACFF!important;
            }   
            
            &:hover {
                border: 1px solid #1FACFF!important;
            }
        }
        

        .page_hide { display: none!important; }
        .page_show { display: flex!important; justify-content: center; }

        .name {
            position: relative;
            background: #d5d5d5;
            border-bottom: 1px solid #d5d5d5;
            padding: 8px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 4px;
            word-break: keep-all;
            color: #000;
            text-align: center;  
            
            &.hover {
                cursor: pointer; 
            }

            &.${props => props.focusUuid} {
                background-color: #ababab;
            }
            .text {    
                max-width: 115px;
                max-height: 30px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                word-break: break-all;
                text-align: left;
                
            }
            svg {margin: 0; cursor: pointer;}
        }

        .paging_label {
            position: absolute;
            bottom: 8px;
            display: flex;
            align-items: center;
            background: #fff;
            color: #000;
            padding: 0 4px;
            border-radius: 4px;

            .page-selector {
                display: inline-flex;
                gap: 8px;
            }

            .icon_hide {
                visibility: hidden;
            }

            svg {
                cursor: pointer;
            }

            input {
                width: 50px;
                text-align: center;
                font-size: 16px;
                border: 1px solid #d5d5d5;

                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
            }
        }

        .pdf_thumb {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 8px;
            padding: 12px 0;

            &_true {
                height: calc(100% - 77px);
                overflow: auto;
            }
        } 

        .document_loading { text-align: center; }
    }
`;

function ShareDocumentList({
    t, dispatch, shareDocumentPermission, isWhiteBoard, list,
    focusItem
}) {
    const [depthItem, onDepthItem] = useState(false);

    const setOnDepthItem = (item, index = DEFAULT_INDEX) => {
        if (item.isWhiteBoard) {
            // focus item 
            onDepthItem(false);
            dispatch(setFocusShareDocument(item.uuid, index, true, false));
        } else {
            onDepthItem(item);
        }
    }

   useEffect(() => {
        if (isWhiteBoard) onDepthItem(false);
    }, [isWhiteBoard]);

    useEffect(() => {
        if (!list.has(focusItem.uuid)) onDepthItem(false);
    }, [list]);

    return (    
        <>
            <DocumentListStyled isWhiteBoard={isWhiteBoard} depthItem={depthItem} focusUuid={focusItem.uuid} focusIndex={focusItem.index}> 
                <dl className="document_item">                
                    <>
                        { list && 
                            [...list].map(([uuid, item]) => {
                                if (item.page === 'vod') return null;
                                return (
                                    <React.Fragment key={item.uuid}>
                                        <DocumentItem t={t} shareDocumentPermission={shareDocumentPermission} focusItem={focusItem}
                                            item={item} depthItem={depthItem} setOnDepthItem={setOnDepthItem} 
                                        /> 
                                    </React.Fragment>
                                );
                            }) }
                    </> 
                </dl>
            </DocumentListStyled>
        </>
    );
}

function _mapStateToProps(state, ownProps) {
    const list = getFilterDocumentListByMode(state, ownProps.isWhiteBoard);
    const focusItem = getFocusItem(state, ownProps.isWhiteBoard);

    return {
        list,
        focusItem
    };
}

export default translate(connect(_mapStateToProps)(ShareDocumentList));